import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, BookOpen, MessageSquareQuote } from 'lucide-react';
import LatestCalendar from '../upcoming/LatestCalendar';
import './Upcoming.css';
import vjgroup from '../../../assets/images/groupphoto24.png';
import princimsg from '../../../assets/images/princimsg.jpg';

const config = require('../../../config.json');

export default function UpcomingMain() {
  const [insights, setInsights] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchActiveInfo();
  }, []);

  const generateDate = async () => {
    const d = new Date();
    const pad = (n) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const fetchActiveInfo = async () => {
    try {
      setLoaded(false);
      const startDate = await generateDate();
      const clientID = "VJCollege";
      const searchOption = "UpComing Events";
      
      const response = await axios.get(
        `${config.api.invokeURL}/dashboard/infodesk?clientID=${clientID}&startDate=${startDate}&searchOption=${searchOption}`,
        {
          headers: {
            'x-api-key': config.api.key
          }
        }
      );

      if (response.data && response.data.length > 0) {
        const result = response.data.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
        setInsights(result);
      } else {
        setInsights([]);
      }
    } catch (error) {
      console.error("Error fetching upcoming events:", error);
      setInsights([]);
    } finally {
      setLoaded(true);
    }
  };

  const hasEvents = loaded && insights && insights.length > 0;
  // If events exist: 3 columns (lg={4}). If no events: 2 columns (lg={6})
  const colSpan = hasEvents ? 4 : 6;

  return (
    <section className="vj-highlights-section">
      <Row className="g-4 align-items-stretch">
        
        {/* Card 1: Upcoming Events - Displayed only when active events exist */}
        {hasEvents && (
          <Col lg={4} md={6} sm={12} className="d-flex">
            <div className="vj-modern-card w-100">
              <div className="vj-card-header">
                <div className="header-left">
                  <div className="vj-icon-badge">
                    <Calendar size={20} />
                  </div>
                  <h3 className="vj-card-title">Upcoming Events</h3>
                </div>
              </div>
              <div className="vj-card-body pt-0 px-2.5 pb-2.5">
                <LatestCalendar insights={insights} loaded={loaded} />
              </div>
            </div>
          </Col>
        )}

        {/* Card 2: About VJ */}
        <Col lg={colSpan} md={6} sm={12} className="d-flex">
          <div className="vj-modern-card w-100">
            <div className="vj-card-header">
              <div className="header-left">
                <div className="vj-icon-badge burgundy">
                  <BookOpen size={20} />
                </div>
                <h3 className="vj-card-title">About Vidyajyoti</h3>
              </div>
            </div>
            <div className="vj-card-media">
              <img 
                src={vjgroup} 
                alt="Vidyajyoti College Community" 
                loading="lazy" 
                style={{ objectPosition: 'center 20%' }}
              />
            </div>
            <div className="vj-card-body">
              <p className="line-clamp-4">
                Vidyajyoti has a long history of about 150+ years. Founded as a seminary in 1879 in Asansol and later transferred to Kurseong as St. Mary's College, Vidyajyoti stands today as a premier Jesuit center for contextual theology and transformative formation.
              </p>
              <div className="vj-card-footer-action">
                <Link to="/about/history" className="vj-btn-outline">
                  Read History <ArrowRight size={16} />
                </Link>
              </div>
            </div>
          </div>
        </Col>

        {/* Card 3: Principal's Message */}
        <Col lg={colSpan} md={hasEvents ? 12 : 6} sm={12} className="d-flex">
          <div className="vj-modern-card w-100">
            <div className="vj-card-header">
              <div className="header-left">
                <div className="vj-icon-badge burgundy">
                  <MessageSquareQuote size={20} />
                </div>
                <h3 className="vj-card-title">Principal's Desk</h3>
              </div>
            </div>
            <div className="vj-card-media vj-card-media-contain">
              <img 
                src={princimsg} 
                alt="Principal Fr. Raj Kumar SJ" 
                loading="lazy" 
              />
            </div>
            <div className="vj-card-body">
              <p className="line-clamp-4">
                "Vidyajyoti is not just an academic institution. It is an ATTITUDE of theologizing in context. It shapes a way of life where the life-realities, struggles, and aspirations of people become our starting point for reflection."
              </p>
              <div className="vj-card-footer-action">
                <Link to="/about/principalmessage" className="vj-btn-primary">
                  Read Message <ArrowRight size={16} />
                </Link>
              </div>
            </div>
          </div>
        </Col>

      </Row>
    </section>
  );
}
